import { useEffect, useState } from 'react'
import { registry, type Takeaway } from '../lib/registry'

/**
 * Everything learned the expensive way.
 *
 * Kept here rather than only in the repo that taught it, because most of these
 * were learned on ONE project and apply to all of them — and a lesson filed
 * inside the project that taught it is a lesson the next project never sees.
 *
 * Scars first. They are the ones that cost something.
 */
const CATEGORIES = ['security', 'data', 'deploy', 'testing', 'process', 'product', 'platform']

export default function Takeaways() {
  const [items, setItems] = useState<Takeaway[]>([])
  const [category, setCategory] = useState<string | null>(null)

  useEffect(() => { void registry.takeaways(category ?? undefined).then((d) => setItems(d.takeaways)) }, [category])

  const scars = items.filter((t) => t.severity === 'scar').length

  return (
    <section>
      <header className="page-head">
        <div>
          <h1>Takeaways</h1>
          <p className="muted">
            {items.length} of them, {scars} of which cost something real.
            The rule comes first — it is what you need at the moment you are about to repeat the mistake.
          </p>
        </div>
      </header>

      <nav className="chips">
        <button className={!category ? 'on' : ''} onClick={() => setCategory(null)}>everything</button>
        {CATEGORIES.map((c) => (
          <button key={c} className={category === c ? 'on' : ''} onClick={() => setCategory(c)}>{c}</button>
        ))}
      </nav>

      <ul className="takeaways">
        {items.map((t) => (
          <li key={t.id} className={t.severity === 'scar' ? 'scar' : ''}>
            <p className="rule">{t.rule}</p>
            {t.why && <p className="why">{t.why}</p>}
            <p className="meta">
              <span className="chip">{t.category}</span>
              {t.severity === 'scar' && <span className="chip chip-scar">cost us</span>}
              {t.unit_name && <span className="muted small">{t.unit_name}</span>}
              {t.component_name && <span className="muted small">· {t.component_name}</span>}
            </p>
          </li>
        ))}
      </ul>
    </section>
  )
}
